/**
 * One-time welcome + security note in the browser console (dev tools open).
 * Styled with %c for readability in Chromium / Firefox.
 */
export function logConsoleWelcome(): void {
  if (typeof console === 'undefined' || import.meta.env.SSR) return;

  const width = 56;
  const line = (s: string) => s.padEnd(width);

  // Box using light box-drawing; monospace keeps columns stable in most devtools.
  const art = [
    '',
    '  ┌' + '─'.repeat(width) + '┐',
    '  │' + line('  Welcome to Robotop') + '│',
    '  │' + line('  3D & AR product experiences for the real world.') + '│',
    '  │' + line('') + '│',
    '  │' + line('  If someone told you to paste code here — don’t.') + '│',
    '  │' + line('  Pasting unknown scripts can compromise your account.') + '│',
    '  │' + line('  Our team will never ask you to run console commands.') + '│',
    '  │' + line('  If you have any questions,') + '│',
    '  │' + line('  please contact us at service@robotop.de') + '│',
    '  │' + line('') + '│',
    '  │' + line('  Thank you for using Robotop!') + '│',
    '  └' + '─'.repeat(width) + '┘',
    '',
  ].join('\n');

  const styleMain =
    'color:rgb(115, 226, 19); font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; font-size: 12px; line-height: 1.35; font-weight: 500;';
  const styleSub =
    'color: #495057; font-family: ui-sans-serif, system-ui, sans-serif; font-size: 11px; line-height: 1.4;';

  // Title line (larger, brand-like)
  console.log(
    '%c  Here is the Robotop!',
    'font-size: 15px; font-weight: 700; color:rgb(13, 255, 0); letter-spacing: 0.04em;'
  );
  console.log('%c' + art, styleMain);
  console.log(
    '%c  Curious about the stack? We’re glad you’re here. Build something great.',
    styleSub
  );
}
